import React, { useState, useCallback } from 'react'

import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Modal, TextArea } from 'Components/atoms'
import colors from 'Assets/colors'

import { Container, Content, Title, ConfirmButton } from './styled'
import CancellationReasonSelector from './cancellationReasonSelector'

const ModalCancelOrder = ({ showModal, setShowModal, width, height, order, onConfirm, borderRadius }) => {
  const { t } = useTranslation()
  const [description, setDescription] = useState('')
  const [motive, setMotive] = useState('')

  const handleChange = useCallback(e => {
    setDescription(e.target.value)
  }, [])

  const handleChangeMotive = useCallback(selectedMotive => {
    setMotive(selectedMotive)
  }, [])

  const handleConfirm = () => {
    onConfirm(description, motive)
    setDescription('')
  }

  return (
    <Modal
      isOpen={showModal}
      setIsOpen={setShowModal}
      width={width}
      height={height}
      borderRadius={borderRadius}
      bottomBackground={colors.gray3}
    >
      <Container>
        <Content>
          <Title>{`${t('cancelOrder')} ${order.id}`}</Title>
          <CancellationReasonSelector onChange={handleChangeMotive} />
          <TextArea
            value={description}
            onChange={handleChange}
            placeholder={t('descCancelHelp')}
            multiple
            padding='0.5rem 1rem'
            background='#F4F1F1'
            rows={5}
          />
        </Content>
        <ConfirmButton onClick={handleConfirm} disabled={!description || !motive}>
          {t('ticketingActionCancelOrder')}
        </ConfirmButton>
      </Container>
    </Modal>
  )
}

export default ModalCancelOrder

ModalCancelOrder.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  onConfirm: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  order: PropTypes.object,
  borderRadius: PropTypes.string,
}

ModalCancelOrder.defaultProps = {
  showModal: false,
  setShowModal: () => {},
  onConfirm: () => {},
  order: {},
  width: '800px',
  height: '470px',
  borderRadius: '4px',
}
